var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-nav"},[_c('nav',[_c('ul',{ref:"navItems",staticClass:"nav-items"},_vm._l((_vm.navItems),function(navItem){return _c('li',{key:navItem.model,ref:navItem.model,refInFor:true,staticClass:"nav-item",class:{
          active: navItem.model === _vm.tabItemActive.model
        },on:{"click":function($event){$event.preventDefault();return _vm.select(navItem)}}},[_c('VNode',{attrs:{"node":navItem.nameSlot,"name":navItem.name}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }